import { render, staticRenderFns } from "./CollabRequest.vue?vue&type=template&id=7684c82c&scoped=true"
import script from "./CollabRequest.vue?vue&type=script&lang=js"
export * from "./CollabRequest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7684c82c",
  null
  
)

export default component.exports